module.exports = __webpack_public_path__ + "static/img/221014-Police-ba.c7ce9cc8.png";